import ListaLibroDiario from '../componentes/ListaLibroDiario.vue'
import FormLibroDiario from '../componentes/FormLibroDiario.vue'

const routes = [
   ...route(`/lista-libro-diario`, ListaLibroDiario, {
     Auth: true,    
  }),
  ...route(`/guardar-libro-diario`, FormLibroDiario, {
	Auth: true,    
 }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes